import '../Register/Register.scss';
import React from 'react';
import { useFormik } from 'formik';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';

const ForgotPassword = () => {

    const navigate = useNavigate();

    const formik = useFormik({
        initialValues: {
            admin_email: "",
        },
        

        //second parameter
        validate: (values) => {
            const error = {}   //create blank array

            if (!values.admin_email) {
                error.admin_email = "Please Enter valid Email"
            }
           

            return error   // jo arror condition sachi no pade to aayathi return thai ne bydefualt blank mokli deshe
        },
        onSubmit: async (value) => {
            console.log(value.admin_email);
            localStorage.setItem('forgotEmail',value.admin_email)

            axios({
                method: 'POST',
                url: 'http://localhost:3010/admin/forgotPassword',
                data: value
            })
            .then(function (res) {
                console.log(res, "create data")
                navigate("/otppage");
            })
            .catch(function (res) {
                console.log(res)
                toast.error("Envalid Credential")

            })
        }
    })


    return (
        <>
            <div className="banner  mt-5">
                <div className="row signin m-0">
                    <div className="text-white mt-5 ps-5">
                        <a href='/admin/home' className='text-white text-decoration-none'><h6 className=''>Forgot &nbsp; / &nbsp; Password </h6></a>
                        <h3 className="text-white">admin Forgot Password</h3>
                    </div>
                </div>

                <div className="container register-form mb-5">
                    <div className="row justify-content-center">
                        <div className="box row p-3 mt-5 border border-secondary-subtle rounded">
                            <div className="d-flex justify-content-center">
                                <h2>Forgot Here</h2>
                            </div>

                            <form method="post" onSubmit={formik.handleSubmit}>
                                <div className="row mt-4 my-4">
                                    <div className="col-md-12 col-12 mt-3">
                                        <label>Email or Mobile Number </label>
                                        <input
                                            type="email"
                                            name="admin_email"
                                            value={formik.values.admin_email}
                                            onChange={formik.handleChange}
                                            className="w-100 form-control shadow-none mt-2"
                                            placeholder="Email or Mobile No"
                                        />
                                        {formik.touched.admin_email && formik.errors.admin_email ? (
                                            <p className="text-danger">{formik.errors.admin_email}</p>
                                        ) : null}
                                    </div>

                                    

                                    

                                    <div className="d-flex justify-content-center">
                                        <button
                                            type="submit"
                                            className="submit-btn w-25 mt-4 text-white rounded py-2"
                                        >
                                            Submit
                                        </button>
                                    </div>

                                    <div className="divider d-flex align-items-center my-4 py-0">
                                        <span className='fs-6 px-4'>Or Continue With</span>
                                    </div>

                                   
                                    <div className="signup-link d-inline-flex justify-content-center mt-3">
                                        <p>Don't have an account? <Link to={'/adminLogin'} className='font-weight-bold text-black text-decoration-none'>Sign in</Link></p>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ForgotPassword;
